import styled from "styled-components";

const EllipsisSpan = styled.div`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: ${(props) => (props.ellipsis ? "pointer" : "default")};
`;

export default EllipsisSpan;
